import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/discount_settlement_rules',
  component: Management,
  redirect: '/discount_settlement_rules/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/discount_settlement_rules/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listDiscountSettlementRules
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/discount_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listDiscountSettlementRules,
            tabName: 'all'
          }
        },
        {
          path: 'enabled',
          component: () => import('@/views/discount_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listDiscountSettlementRules,
            tabName: 'enabled'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/discount_settlement_rules/ListTable'),
          meta: {
            auth: Auth.listDiscountSettlementRules,
            tabName: 'disabled'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/discount_settlement_rules/New'),
      meta: {
        auth: Auth.createDiscountSettlementRule
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/discount_settlement_rules/Edit'),
      meta: {
        auth: Auth.updateDiscountSettlementRule
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/discount_settlement_rules/DetailLayout'),
      meta: {
        auth: Auth.showDiscountSettlementRule
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/discount_settlement_rules/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showDiscountSettlementRule
          }
        },
        // 站结算记录
        {
          path: 'ev_charging_station_settlements',
          component: () => import('@/views/discount_settlement_rules/details/EvChargingStationSettlements'),
          meta: {
            tabName: 'ev_charging_station_settlements', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listEvChargingStationSettlements
          }
        },
        // 优惠结算记录
        {
          path: 'discount_settlement',
          component: () => import('@/views/discount_settlement_rules/details/DiscountSettlements'),
          meta: {
            tabName: 'discount_settlement', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrderDiscountSettlements
          }
        }
      ]
    }
  ]
}
